import React from 'react';

export const AttachmentDropIcons = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Photo / picture icon */}
    <g transform="translate(0 2) rotate(-12 12 12)">
      <path
        d="M14 3.5H10C6.22876 3.5 4.34315 3.5 3.17157 4.67157C2 5.84315 2 7.72876 2 11.5V13.5C2 17.2712 2 19.1569 3.17157 20.3284C4.34315 21.5 6.22876 21.5 10 21.5H14C17.7712 21.5 19.6569 21.5 20.8284 20.3284C22 19.1569 22 17.2712 22 13.5V11.5C22 7.72876 22 5.84315 20.8284 4.67157C19.6569 3.5 17.7712 3.5 14 3.5Z"
        fill="#FFF3E0"
        stroke="#FB8C00"
        strokeWidth="1.5"
      />
      <circle
        cx="8.5"
        cy="9"
        r="1.5"
        fill="#FFCA28"
        stroke="#FB8C00"
        strokeWidth="1.5"
      />
      <path
        d="M21.5 17.5L16.348 11.8797C16.1263 11.6377 15.8131 11.5 15.485 11.5C15.1744 11.5 14.8766 11.6234 14.6571 11.8429L10 16.5L7.83928 14.3393C7.62204 14.122 7.32741 14 7.02019 14C6.68931 14 6.37423 14.1415 6.15441 14.3888L2.5 18.5"
        fill="#FFE082"
        stroke="#FB8C00"
        strokeWidth="1.5"
      />
    </g>

    {/* Clipboard / list-with-lock icon */}
    <g transform="translate(12 14) rotate(10 12 12)">
      <path
        d="M20.4999 10.5V10C20.4999 6.22876 20.4999 4.34315 19.3284 3.17157C18.1568 2 16.2712 2 12.4999 2H11.5C7.72883 2 5.84323 2 4.67166 3.17156C3.50009 4.34312 3.50007 6.22872 3.50004 9.99993L3.5 14.5C3.49997 17.7874 3.49996 19.4312 4.40788 20.5375C4.57412 20.7401 4.75986 20.9258 4.96242 21.0921C6.06877 22 7.71249 22 10.9999 22"
        fill="#E8F5E9"
        stroke="#388E3C"
        strokeWidth="1.5"
      />
      <path
        d="M7.5 7H16.5"
        stroke="#388E3C"
        strokeWidth="1.5"
      />
      <path
        d="M7.5 12H13.5"
        stroke="#388E3C"
        strokeWidth="1.5"
      />
      <path
        d="M20.5 20L20.5 17C20.5 15.5706 19.1569 14 17.5 14C15.8431 14 14.5 15.5706 14.5 17L14.5 20.5C14.5 21.3284 15.1716 22 16 22C16.8284 22 17.5 21.3284 17.5 20.5V17"
        fill="#A5D6A7"
        stroke="#388E3C"
        strokeWidth="1.5"
      />
    </g>

    {/* Code brackets / arrows icon */}
    <g transform="translate(24 -2) rotate(5 12 12)">
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        fill="#E3F2FD"
        stroke="#1976D2"
        strokeWidth="1.5"
      />
      <path
        d="M16 10L17.2265 11.0572C17.7422 11.5016 18 11.7239 18 12C18 12.2761 17.7422 12.4984 17.2265 12.9428L16 14"
        stroke="#1976D2"
        strokeWidth="1.5"
      />
      <path
        d="M8 10L6.77346 11.0572C6.25782 11.5016 6 11.7239 6 12C6 12.2761 6.25782 12.4984 6.77346 12.9428L8 14"
        stroke="#1976D2"
        strokeWidth="1.5"
      />
      <path
        d="M13 9L11 15"
        stroke="#2196F3"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);